module.exports = __webpack_public_path__ + "img/3.7d9aa146.jpg";